<template>
  <div class="auth-container">
    <div class="auth-card">
      <h2>Admin Access</h2>
      <p>Please enter the admin password to continue:</p>

      <form @submit.prevent="handleLogin">
        <div class="input-group">
          <input
            type="email"
            v-model="email"
            placeholder="Admin Email"
            class="email-input"
            :class="{ 'error': showError }"
            @input="showError = false"
            required
          />
          <input
            type="password"
            v-model="password"
            placeholder="Admin Password"
            class="password-input"
            :class="{ 'error': showError }"
            @input="showError = false"
            required
          />
          <button type="submit" class="login-button" :disabled="!email || !password">
            Access Admin
          </button>
        </div>
      </form>

      <div v-if="showError" class="error-message">
        Invalid password. Please try again.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminAuth',
  data() {
    return {
      email: '',
      password: '',
      showError: false
    };
  },
    methods: {
    async handleLogin() {
      try {
        // Use Supabase Auth for authentication
        const { supabase } = await import('../supabaseClient.js');

        const { error } = await supabase.auth.signInWithPassword({
          email: this.email,
          password: this.password
        });

        if (error) {
          throw error;
        }

        // Success - emit authenticated event
        this.$emit('authenticated');
      } catch (error) {
        console.error('Admin login error:', error);
        this.showError = true;
        this.password = '';
      }
    }
  }
};
</script>

<style scoped>
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 20px;
}

.auth-card {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  text-align: center;
}

h2 {
  color: #2c3e50;
  margin-bottom: 10px;
}

p {
  color: #7f8c8d;
  margin-bottom: 30px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.email-input,
.password-input {
  padding: 12px 16px;
  border: 2px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.email-input:focus,
.password-input:focus {
  outline: none;
  border-color: #3498db;
}

.email-input.error,
.password-input.error {
  border-color: #e74c3c;
}

.login-button {
  background-color: #3498db;
  color: white;
  border: none;
  padding: 12px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.login-button:hover:not(:disabled) {
  background-color: #2980b9;
}

.login-button:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.error-message {
  color: #e74c3c;
  font-size: 14px;
  margin-top: 15px;
  padding: 10px;
  background-color: #fdf2f2;
  border: 1px solid #fecaca;
  border-radius: 5px;
}
</style>
